import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Combobox } from "@/components/ui/combobox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mask } from "@/types/mask";

type TestLabelFilterProps = {
  selectedMask: Mask | undefined;
  onMaskChange: (mask: string) => void;
  masks: Mask[];
  searchQuery: string;
  onSearchChange: (query: string) => void;
};
export function TestLabelFilter({
  selectedMask,
  onMaskChange,
  masks,
  searchQuery,
  onSearchChange,
}: TestLabelFilterProps) {
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex gap-4">
          <div className="space-y-2">
            <Label>Search Test Labels</Label>
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
              <Input
                type="text"
                placeholder="Search by name, description, or mask"
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
                className="pl-10 w-[150px] lg:w-[350px]"
              />
            </div>
          </div>
          <div className="space-y-2">
            <Label>Filter by Mask</Label>
            <div className="flex items-end gap-2">
              <Combobox
                className="w-48"
                options={masks.map((m) => ({
                  key: m.id,
                  value: m.id,
                  label: m.name,
                }))}
                placeholder="All masks"
                searchPlaceholder="Search masks"
                onChange={onMaskChange}
                value={selectedMask?.id}
              />
              <Button
                disabled={!selectedMask?.id}
                onClick={() => onMaskChange("")}
                variant="secondary"
              >
                Clear filter
              </Button>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
